var s = Object.defineProperty;
var g = (e, t, a) => t in e ? s(e, t, { enumerable: !0, configurable: !0, writable: !0, value: a }) : e[t] = a;
var n = (e, t, a) => g(e, typeof t != "symbol" ? t + "" : t, a);
class D {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(t = {}) {
    // optional for testing purposes only
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    n(this, "authData");
    this.authData = t;
  }
  get provider() {
    var t;
    return (t = this.authData) == null ? void 0 : t.provider;
  }
  get token() {
    var t, a, o, r, h, i, u;
    switch ((t = this.authData) == null ? void 0 : t.provider) {
      case "google":
        return ((o = (a = this.authData) == null ? void 0 : a.authentication) == null ? void 0 : o.idToken) || ((r = this.authData) == null ? void 0 : r["google/token"]);
      case "cognito":
        return ((i = (h = this.authData) == null ? void 0 : h.idToken) == null ? void 0 : i.jwtToken) || ((u = this.authData) == null ? void 0 : u["cognito/token"]);
      default:
        return "";
    }
  }
  get refreshTokenExpiration() {
    var t, a;
    switch ((t = this.authData) == null ? void 0 : t.provider) {
      case "cognito":
        return (a = this.authData) == null ? void 0 : a.refreshTokenExpiration;
      default:
        return;
    }
  }
  // TODO: remove `profilePhoto` once `/api/admin/me` updated to return image url similar to `/api/sub/me`
  // We need to display the image that is driven by BE logic (accounting for both Google or Cognito/Cloudinary images)
  get profilePhoto() {
    var t;
    return ((t = this.authData) == null ? void 0 : t.photoUrl) || this.authData["google/image"] || "";
  }
}
export {
  D as AuthModel
};
